if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');

        if (document.querySelector('cart-drawer'))
          this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.form.addEventListener('change', this.onVariantChange.bind(this));
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });

            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart?.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner')?.classList.add('hidden');
            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;

        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) this.errorMessage.textContent = errorMessage;
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings?.addToCart || 'In den Warenkorb';
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      onVariantChange() {
        const selectedVariantId = this.variantIdInput?.value;
        if (!selectedVariantId) return;

        fetch(window.location.pathname + '.js')
          .then((res) => res.json())
          .then((product) => {
            const variant = product.variants.find((v) => v.id == selectedVariantId);
            if (variant) {
              console.log('[DEBUG] Dispatching custom variant:change event', variant);
              document.dispatchEvent(new CustomEvent('variant:change', {
                detail: { variant }
              }));
               // ✅ NEU: Warenkorb-Button je nach Verfügbarkeit anpassen
        // variant.available === true  -> Button aktiv
        // variant.available === false -> Button deaktiviert
        this.toggleSubmitButton(!variant.available);
            }
          });
      }
    }
  );
}

console.log('[DEBUG] Waiting for variant:change event...');
document.addEventListener('variant:change', function(event) {
  console.log('[DEBUG] variant:change triggered', event.detail.variant);

  const variant = event.detail.variant;
  const priceEl = document.querySelector('[data-product-price]');
  const compareEl = document.querySelector('[data-compare-price]');

  // 🏷 Preis aktualisieren
  if (variant && priceEl) {
    priceEl.textContent = (variant.price / 100).toFixed(2) + ' €';
  }

  if (variant && compareEl) {
    if (variant.compare_at_price > variant.price) {
      compareEl.textContent = (variant.compare_at_price / 100).toFixed(2) + ' €';
      compareEl.style.display = 'inline';
    } else {
      compareEl.textContent = '';
      compareEl.style.display = 'none';
    }
  }

  // 🟢 NEU: Warenkorb-Button nach Variantenwechsel sauber setzen
  const addButton =
    document.querySelector('product-form [type="submit"]') ||
    document.querySelector('product-form button[name="add"]');

  if (addButton) {
    if (variant && variant.available) {
      // Variante verfügbar → Button aktiv
      addButton.removeAttribute('disabled');
      addButton.removeAttribute('aria-disabled');
      addButton.classList.remove('disabled');
    } else {
      // Variante nicht verfügbar → Button deaktivieren
      addButton.setAttribute('disabled', 'disabled');
      addButton.setAttribute('aria-disabled', 'true');
      addButton.classList.add('disabled');
    }
  }
});
